import { defineRecipe } from '@chakra-ui/react';

export const linkRecipe = defineRecipe({
  className: 'chakra-link',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    outline: 'none',
    gap: '1.5',
    cursor: 'pointer',
    borderRadius: 'l1',
    focusRing: 'outside',
    _focus: {
      outline: 'none',
    },
  },
  variants: {
    variant: {
      default: {
        color: 'primary.dark',
        position: 'relative',
        gap: '4',
        _after: {
          position: 'absolute',
          content: '""',
          display: 'block',
          w: '0',
          h: '3px',
          bg: 'primary.light',
          opacity: 0,
          transitionProperty: 'width, opacity',
          transitionDuration: 'slower',
          borderRadius: 'full',
          bottom: '-2px',
        },
        _hover: {
          _after: {
            w: '100%',
            opacity: 1,
          },
        },
      },
      underline: {
        color: 'colorPalette.fg',
        textDecoration: 'underline',
        textUnderlineOffset: '3px',
        textDecorationColor: 'currentColor/20',
      },
      plain: {
        color: 'colorPalette.fg',
        _hover: {
          textDecoration: 'underline',
          textUnderlineOffset: '3px',
          textDecorationColor: 'currentColor/20',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
